import React, { Component } from "react"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { withTranslation } from "react-i18next"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import { isEmpty, map, size } from "lodash"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import DeleteModal from "../../../components/Common/DeleteModal";
import { addProjectContact, getProjectContact, updateProjectContact, deleteProjectContact, getProjectUUIDAction} from "../../../store/projects/actions"
import MaskedInput from "react-text-mask";
import { formatPhoneNumber } from "../../../helpers/phoneUtils";

import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Nav,
  NavItem,
  TabContent,
  FormGroup,
  Label,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import ProjectSidebar from "../../../components/VerticalLayout/ProjectSidebar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import SetupMenu from "./menu/setup-menu";
import SetupBreadcrumbs from "components/Common/Setup";
import RsAdNew from "components/buttons/Adnew";
import UpdateButton from "components/buttons/updateBtn";
import SaveButton from "components/buttons/save";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import PhoneInputField from "components/dropdowns/PhoneInputField";
import SafeField from "helpers/SafeField";



class ProjectsContact extends Component {
  constructor(props) {
    super(props)
    this.state = {
      contact: "",
      
    }
    this.handleProjectContact = this.handleProjectContact.bind(this)
    this.onClickDelete = this.onClickDelete.bind(this);
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.toggleAddNew = this.toggleAddNew.bind(this);
  }
  toggleNew() {
    this.setState(prevState => ({
      isAddNew: !prevState.isAddNew
    }));
  }

  toggleAddNew() {
    this.setState({  isAddNew: !this.state.isAddNew });
  }
  handleProjectContact(value){
    this.props.addProjectContact(value,(status)=>{
      if(status==true){
         this.toggleNew();
      }
    });
   
  }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (contact) => {
    this.setState({ contact: contact });
    this.setState({ deleteModal: true });
  };

  handleDeleteContact = () => {
    const { onDeleteContact } = this.props;
    const { contact } = this.state;
    if (contact.id !== undefined) {
      onDeleteContact(contact);
      this.setState({ deleteModal: false });
    }
  };
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
  componentDidMount(prevProps) {
    const { match: { params }, onGetProjectContact , contacts, ongetProjectUUIDAction}= this.props;
    if (params &&  params.projectId) {
      onGetProjectContact(params.projectId);
      ongetProjectUUIDAction(params.projectId);
      this.setState({ contacts });
    
    }else{
      this.props.history.push('/my-project')
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { contacts } = this.props;
    if (!isEmpty(contacts) && size(prevProps.contacts) !== size(contacts)) {
      this.setState({ contacts: {}, isEdit: false });
    }
  }
  toggleRightCanvas() {
    this.setState({ contact: "", isEdit: false, isRight: !this.state.isRight });
    this.toggle();
  }
  toggleRightCanvas = arg => {
    const contact = arg;
    //
    this.setState({
      contact: {
    
        id:contact.id,
        projectId: contact.projectId,
        projectGuid:contact.projectGuid,
        projectContactId:contact.projectContactId,
        pContactId:contact.pContactId,
        pContactDepartment: contact.pContactDepartment,
        pContactName: contact.pContactName,
        phone: contact?.projectContact?.phone,
        phoneExt:contact?.projectContact?.phoneExt,
        email: contact?.projectContact?.email,
        mobile: contact?.projectContact?.mobile,
        fax: contact?.projectContact?.fax,
      },
      isEdit: true,
    });
    this.toggle();
  };

  render() {
   
    const { contacts, onUpdateProjectContact, projectData, isResponsive } = this.props;
    const { isEdit, deleteModal } = this.state;
    const contact = this.state.contact;
      return (
      <React.Fragment>
          {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
         <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteContact}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
         <ToastContainer autoClose={2000} />
         <div className="page-content project-page-content">

<MetaTags>
  <title>Campaigns | Realty Space</title>
</MetaTags>
<Container fluid className="ps-0 ">
      <Row>
          <Col sm='2' className="pe-0" >
          <ProjectSidebar isResponsive={isResponsive} />
           </Col>
      <Col sm='10' className="ps-0">
      <Row className="project-header">
         <Col sm="7">
      <SetupBreadcrumbs title={this.props.t("Projects")} breadcrumbItem={this.props.t("Contact")} />
      </Col>
      <Col sm="4">
      <h2 className="">{this.props.t( projectData.projectName)}</h2>
      </Col>
      </Row>
      <SetupMenu isResponsive={isResponsive}  />
            <Card>
                  <CardBody>
                  

                    <TabContent activeTab={this.state.activeTab} className="p-3 text-muted">
                      <Row className="">
                          <Col lg="12">
                          {   projectData.agentId !== 0 && 
                              projectData.projectId === projectData.preConsProjectGuid  ? (
                          <RsAdNew onClick={this.toggleAddNew} className="btn-light float-end mb20">Add New</RsAdNew>
                        ) : null }
                          <div className="clearfix"></div>
                          <div className="table-rep-plugin">
                      <div
                        className="mb-0"
                        data-pattern="priority-columns"
                      >
                      {isResponsive ? (
                        <DataTable
                        className="table table-bordered data-table align-middle table-nowrap mb-0 me-2"
                        value={contacts}
                        paginator rows={10}
                        expandedRows={this.state.expandedRows}
                        onRowToggle={(e) => this.setState({ expandedRows: e.data })}
                        rowExpansionTemplate={(rowData) => (
                          <table className="table table-sm mb-0 bg-light">
                            <tbody>
                              <tr><th>Department</th><td>{rowData.pContactDepartment || "N/A"}</td></tr>
                              <tr><th>Email</th><td>{rowData.projectContact?.email || "N/A"}</td></tr>
                              <tr><th>Mobile</th><td>{rowData.projectContact?.mobile || "N/A"}</td></tr>
                              <tr><th>Fax</th><td>{rowData.projectContact?.fax || "N/A"}</td></tr>
                            </tbody>
                          </table>
                        )}
                      >
                        <Column expander style={{ width: "3rem" }} />
                        <Column field="pContactName" header="Name" />
                        <Column field="projectContact.phone" header="Phone" />
                        <Column
                          header="Action"
                          body={(rowData) =>
                            projectData.agentId !== 0 && projectData.projectId === projectData.preConsProjectGuid ? (
                              <>
                                <ActionEdit onClick={() => this.toggleRightCanvas(rowData)} />
                                <ActionDelete onClick={() => this.onClickDelete(rowData)} />
                              </>
                            ) : null
                          }
                        />
                      </DataTable>
                      ):(
                        <DataTable className="table table-bordered data-table align-middle table-nowrap mb-0 me-2" value={contacts} paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500 ]} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries " paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown   " tableStyle={{ minWidth: '50rem' }}   >
                            <Column  field="pContactDepartment" header="Department">  </Column>
                            <Column  field="pContactName" header="Contact Name"></Column>
                           <Column
                                  field="projectContact.phone"
                                  header="Phone"
                                 
                                />
                            <Column  field="projectContact.email" header="Email"></Column>
                            <Column  field="projectContact.mobile" header="Mobile"></Column>
                            <Column  field="projectContact.fax" header="Fax"></Column>
                            <Column  field="eventDescription" header="" body={(rowData) =>(
                                projectData.agentId !== 0 && 
                                projectData.projectId === projectData.preConsProjectGuid  ? (
                                <>
                                <ActionEdit  onClick={() => this.toggleRightCanvas(rowData)} /> 
                                <ActionDelete onClick={() => this.onClickDelete(rowData)} />
                                </>
                          ) : null 
                            )}></Column>
                        </DataTable>
                      )}
                      </div>
                    </div>
                          </Col>

                      </Row>


                    
                            

                        </TabContent>
                        </CardBody>
                        </Card>
                        </Col>
                        </Row>
                        <Offcanvas
              isOpen={this.state.isAddNew}
              direction="end"
              toggle={this.toggleAddNew}
            >
              <OffcanvasHeader toggle={this.toggleAddNew}>
                New Contact
              </OffcanvasHeader>
              <OffcanvasBody>
              <Formik
                                enableReinitialize={true}
                                initialValues={{
                                  projectId: projectData.id,
                                  projectGuid:projectData.preConsProjectGuid,
                                  pContactDepartment: '',
                                  pContactName:'',
                                  contactPhone: '',
                                  emailContact: '',
                                  contactMobile: '',
                                  contactFax: ''

                                }}
                                validationSchema={Yup.object().shape({
                                  pContactDepartment: Yup.string().required("This is required"),
                                  pContactName: Yup.string().required("This is required"),
                    
                                  contactMobile: Yup.string().required("This is required"),
                                
                                  emailContact: Yup.string().email('Enter Valid Email').required('This is required')
                                })}

                                onSubmit={this.handleProjectContact }
                              >
                             {({ errors, touched, values, handleChange,handleBlur, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
                     
                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="pContactDepartment">
                              {this.props.t("Department*")}
                            </Label>
                            <SafeField
                                name="pContactDepartment"
                                type="text"
                                onChange={handleChange}
                                className={
                                  "form-control" +
                                  (errors.pContactDepartment && touched.pContactDepartment
                                    ? " is-invalid"
                                    : "")
                                }
                            />
                            <ErrorMessage
                                name="pContactDepartment"
                                component="div"
                                className="invalid-feedback"
                              />
                          </FormGroup>
                        </Col>

                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="pContactName">
                              {this.props.t("Contact Name*")}
                            </Label>
                            <SafeField
                                name="pContactName"
                                type="text"
                                onChange={handleChange}
                                className={
                                  "form-control" +
                                  (errors.pContactName && touched.pContactName
                                    ? " is-invalid"
                                    : "")
                                }
                            />
                            <ErrorMessage
                                name="pContactName"
                                component="div"
                                className="invalid-feedback"
                              />
                          </FormGroup>
                        </Col>

                        <Col md="10">
                         <PhoneInputField
                                  label="Office Phone"
                                  name="contactPhone"
                                  value={values.contactPhone}
                                  setFieldValue={setFieldValue}
                                  error={errors.contactPhone}
                                  touched={touched.contactPhone}
                                  country="ca"
                                  required={false}
                                />
                  
                        </Col>

                        <Col md="2">
                          <FormGroup className="mb-3">
                            <Label htmlFor="phoneExt">
                              {this.props.t("Ext")}
                            </Label>
                            <SafeField
                                name="phoneExt"
                                type="text"
                                onChange={handleChange}
                                className={
                                  "form-control" +
                                  (errors.phoneExt && touched.phoneExt
                                    ? " is-invalid"
                                    : "")
                                }
                            />                            
                            <ErrorMessage
                                name="phoneExt"
                                component="div"
                                className="invalid-feedback"
                              />
                          </FormGroup>
                        </Col>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="emailContact">
                              {this.props.t("Email*")}
                            </Label>
                            <SafeField
                                name="emailContact"
                                type="text"
                                onChange={handleChange}
                                className={
                                  "form-control" +
                                  (errors.emailContact && touched.emailContact
                                    ? " is-invalid"
                                    : "")
                                }
                            />
                            <ErrorMessage
                                name="emailContact"
                                component="div"
                                className="invalid-feedback"
                              />
                          </FormGroup>
                        </Col>
                        <Col md="12">
                        <PhoneInputField
                                  label="Mobile"
                                  name="contactMobile"
                                  value={values.contactMobile}
                                  setFieldValue={setFieldValue}
                                  error={errors.contactMobile}
                                  touched={touched.contactMobile}
                                  country="ca"
                                  required={true}
                                />
                        
                        </Col>
                        <Col md="12">
                         <PhoneInputField
                                  label="Fax"
                                  name="contactFax"
                                  value={values.contactFax}
                                  setFieldValue={setFieldValue}
                                  error={errors.contactFax}
                                  touched={touched.contactFax}
                                  country="ca"
                                  required={false}
                                />
                        
                        </Col>
                        <Col sm="12">
                        <SaveButton>Save</SaveButton>
                       
                        </Col>
                      </Row>

                      </Form>
                  )}
                </Formik>
                         
              </OffcanvasBody>
            </Offcanvas>                 
            <Offcanvas
              isOpen={this.state.isRight}
              direction="end"
              toggle={this.toggleRightCanvas}
            >
              <OffcanvasHeader toggle={this.toggleRightCanvas}>
                Update Contact
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id:contact.id,
                    projectId: contact.projectId,
                    projectGuid:contact.projectGuid,
                    projectContactId:contact.projectContactId,
                    pContactDepartment: contact.pContactDepartment,
                    pContactName: contact.pContactName,
                    pContactId:contact.pContactId,
                    phone: contact.phone,
                    phoneExt:contact.phoneExt,
                    email: contact.email,
                    mobile: contact.mobile,
                    fax: contact.fax
                  }}
                  validationSchema={Yup.object().shape({
                    pContactDepartment: Yup.string().required("This is required"),
                      pContactName: Yup.string().required("This is required"),
                      //phone: Yup.string().required("This is required"),
                      mobile: Yup.string().required("This is required"),
                      //fax: Yup.string().required("This is required"),
                      email: Yup.string().email('Enter Valid Email').required('This is required')
                  })}

                  onSubmit={values => {
                    
                    if (isEdit) {
                      const updateContact = {
                        id:values.id,
                        projectId: values.projectId,
                        projectGuid:values.projectGuid,
                        projectContactId:values.projectContactId,
                        pContactId:values.pContactId,
                        pContactDepartment: values.pContactDepartment,
                        pContactName: values.pContactName,
                        phone: values.phone,
                        phoneExt:values.phoneExt,
                        email: values.email,
                        mobile: values.mobile,
                        fax: values.fax,
                        pContactIsActive: true,
                        agentId: parseInt(localStorage.getItem('userId'))
                      };

                      onUpdateProjectContact(updateContact, (status)=>{
                          if(status==true){
                               this.toggle();
                          }
                      });
                    } else {
                      
                    }

                    //this.setState({ selectedOrder: null });
                   
                  }}
                >
                  {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
                     
                      <Row>
                      <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="pContactDepartment">
                                {this.props.t("Department *")}
                              </Label>
                              <SafeField
                                name="pContactDepartment"
                                type="text"
                                onChange={handleChange}
                                className={
                                  "form-control" +
                                  (errors.pContactDepartment && touched.pContactDepartment
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <ErrorMessage
                                name="pContactDepartment"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>

                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="pContactName">
                                {this.props.t("Contact Name *")}
                              </Label>
                              <SafeField
                                name="pContactName"
                                type="text"
                                onChange={handleChange}
                                className={
                                  "form-control" +
                                  (errors.pContactName && touched.pContactName
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <ErrorMessage
                                name="pContactName"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>

                          <Col md="8">
                           <PhoneInputField
                                  label="Office Phone"
                                  name="phone"
                                  value={values.phone}
                                  setFieldValue={setFieldValue}
                                  error={errors.phone}
                                  touched={touched.phone}
                                  country="ca"
                                  required={false}
                                />
                         
                          </Col>
                          <Col md="4">
                            <FormGroup className="mb-3">
                              <Label htmlFor="phoneExt">
                                {this.props.t("Ext")}
                              </Label>
                              <SafeField
                                name="phoneExt"
                                type="text"
                                onChange={handleChange}
                                className={
                                  "form-control" +
                                  (errors.phoneExt && touched.phoneExt
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                            
                            </FormGroup>
                          </Col>     
                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="email">
                                {this.props.t("Email *")}
                              </Label>
                              <SafeField
                                name="email"
                                type="text"
                                onChange={handleChange}
                                className={
                                  "form-control" +
                                  (errors.emailContact && touched.emailContact
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <ErrorMessage
                                name="email"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>

                          <Col md="12">
                           <PhoneInputField
                                  label="Mobile"
                                  name="mobile"
                                  value={values.mobile}
                                  setFieldValue={setFieldValue}
                                  error={errors.mobile}
                                  touched={touched.mobile}
                                  country="ca"
                                  required={true}
                                />
                            
                          </Col>

                          <Col md="12">
                            <PhoneInputField
                                  label="Fax"
                                  name="fax"
                                  value={values.fax}
                                  setFieldValue={setFieldValue}
                                  error={errors.fax}
                                  touched={touched.fax}
                                  country="ca"
                                  required={false}
                                />
                          
                          </Col>




                      </Row>










                      <div><UpdateButton>Update</UpdateButton></div>

                    </Form>
                  )}
                </Formik>

              </OffcanvasBody>
            </Offcanvas>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

ProjectsContact.propTypes = {
  t:PropTypes.any,
  history:PropTypes.object,
  addProjectContact:PropTypes.func,
  contacts:PropTypes.array,
  match:PropTypes.object,
  onGetProjectContact: PropTypes.func,
  onDeleteContact: PropTypes.func,
  onUpdateProjectContact:PropTypes.func,
  loading:PropTypes.func,
  ongetProjectUUIDAction:PropTypes.func,
  projectData: PropTypes.object,
  isResponsive:PropTypes.object

  

}

const mapStateToProps = ({ Project }) => (
  {
    contacts: Project.contacts,
    projectData: Project.projectData,
    loading:Project.loading

  })

const mapDispatchToProps = dispatch => ({
  ongetProjectUUIDAction: (id) => dispatch(getProjectUUIDAction(id)),
  addProjectContact: (data, callback) => dispatch(addProjectContact(data, callback)),
  onGetProjectContact:(projectId) => dispatch(getProjectContact(projectId)),
  onUpdateProjectContact: (contact, callback) => dispatch(updateProjectContact(contact, callback)),
  onDeleteContact: (id) => dispatch(deleteProjectContact(id))
})

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(withTranslation()(ProjectsContact)))